import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

import * as s from "./ReCaptcha.module.scss";

import { tx } from "src/libs/i18n";
import { Checkbox, P } from "src/views/shared/components";
import { Icons } from "src/libs/assets";

interface Props {
  toggleReCaptcha: () => void;
  reCaptchaValid: boolean;
}

export const ReCaptcha = ({ toggleReCaptcha, reCaptchaValid }: Props) => {
  const reCaptchaRef = React.useRef<ReCAPTCHA>(null);

  const executeReCaptcha = async () => {
    if (!reCaptchaRef.current) return;

    if (reCaptchaValid || !!-process.env.GATSBY_DEV_MODE === true) {
      toggleReCaptcha();
    } else {
      const response = await reCaptchaRef.current.executeAsync();
      if (response && response?.length > 0) {
        toggleReCaptcha();
        reCaptchaRef.current.reset();
      }
    }
  };

  if (!process.env.GATSBY_RECAPTCHA_SITE_KEY) {
    reCaptchaValid = false;
    return null;
  }

  return (
    <>
      <div className={s.reCaptchaContainer}>
        <Checkbox type="check" onChange={executeReCaptcha} selected={reCaptchaValid} />
        <P className={s.reCaptchaText} small>
          {tx("authentication.imNotARobot")}
        </P>
        <img src={Icons.reCaptcha} className={s.reCaptchaIcon} />
      </div>
      <ReCAPTCHA ref={reCaptchaRef} sitekey={process.env.GATSBY_RECAPTCHA_SITE_KEY} size="invisible" />
    </>
  );
};
